"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var NumberToEditorStringConverter = (function () {
    function NumberToEditorStringConverter() {
    }
    NumberToEditorStringConverter.getFactor = function (columnSettings) {
        return columnSettings ? columnSettings.factor : undefined;
    };
    NumberToEditorStringConverter.applyFactor = function (columnSettings, value) {
        var factor = NumberToEditorStringConverter.getFactor(columnSettings);
        if (factor) {
            return value * factor;
        }
        return value;
    };
    NumberToEditorStringConverter.getNumberFormat = function (columnSettings) {
        return columnSettings ? columnSettings.numberFormat : undefined;
    };
    NumberToEditorStringConverter.handleErrorString = function (value) {
        if (value === configuration_1.PlanConfiguration.ERROR_STRING || value === "") {
            return 0;
        }
        if (typeof value !== "number") {
            var base = 10;
            var parsed = parseInt(value.toString(), base);
            if (!parsed) {
                throw new Error("ERROR! Type of value " + value + " is not numeric, but " + typeof value);
            }
            value = parsed;
        }
        return value;
    };
    NumberToEditorStringConverter.applyNumberFormat = function (columnSettings, value) {
        var numberFormat = NumberToEditorStringConverter.getNumberFormat(columnSettings);
        if (numberFormat) {
            return numeral(value).format(numberFormat);
        }
        else {
            return numeral(value).toString();
        }
    };
    NumberToEditorStringConverter.number2Editor = function (value, columnSettings) {
        value = NumberToEditorStringConverter.handleErrorString(value);
        value = NumberToEditorStringConverter.applyFactor(columnSettings, value);
        return NumberToEditorStringConverter.applyNumberFormat(columnSettings, value);
    };
    NumberToEditorStringConverter.getSign = function (input) {
        for (var _i = 0, _a = ["+", "-", "*", "/"]; _i < _a.length; _i++) {
            var sign = _a[_i];
            if (sign === input[0]) {
                return sign;
            }
        }
        return undefined;
    };
    NumberToEditorStringConverter.getPercent = function (input) {
        if (input[input.length - 1] === "%") {
            return "%";
        }
        return undefined;
    };
    NumberToEditorStringConverter.stripInputFromSignAndPercent = function (input, sign, percent) {
        var output = input;
        if (sign) {
            output = output.substr(1);
        }
        if (percent) {
            output = output.substr(0, output.length - 1);
        }
        return output;
    };
    NumberToEditorStringConverter.editor2Number = function (value, columnSettings) {
        var sign = NumberToEditorStringConverter.getSign(value);
        var percent = NumberToEditorStringConverter.getPercent(value);
        value = NumberToEditorStringConverter.stripInputFromSignAndPercent(value, sign, percent);
        var numberValue = numeral().unformat(value);
        if (isNaN(numberValue)) {
            numberValue = 0;
        }
        var factor = NumberToEditorStringConverter.getFactor(columnSettings);
        if (columnSettings.minValue !== undefined && numberValue < columnSettings.minValue) {
            numberValue = columnSettings.minValue;
        }
        if (columnSettings.maxValue !== undefined && numberValue > columnSettings.maxValue) {
            numberValue = columnSettings.maxValue;
        }
        var result = numberValue;
        if (typeof factor !== "undefined" &&
            (percent !== "%" && sign !== "*" && sign !== "/")) {
            result = numberValue / factor;
        }
        if (!sign && !percent) {
            return parseFloat(result.toString());
        }
        return sign + result + percent;
    };
    return NumberToEditorStringConverter;
}());
exports.NumberToEditorStringConverter = NumberToEditorStringConverter;
//# sourceMappingURL=numberEditorConverter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/cellProvider/numberEditorConverter.js
// module id = 17
// module chunks = 0